import { useMemo } from 'react'

import { useAppSelector } from 'redux/toolkit/hooks'

import { UserRole } from 'config/userRole'
import useUserRights from 'components/libs/userRights/useUserRights'

export const useIsAccountHelpdeskUser = (): boolean => {
  const { userInfo, isHelpdesk } = useAppSelector(_store => ({
    userInfo: _store.auth.accessTokenObject?.userInfo,
    isHelpdesk: _store.auth.accessTokenObject?.roleType === UserRole.HELPDESK_ROLE
  }))
  const { userFeatures } = useUserRights()
  const isBccUser = !!userInfo && Object.keys(userInfo).length > 0

  return useMemo(
    () => isHelpdesk && isBccUser && !!userFeatures?.accountHelpdeskFeatureEnabled,
    [isHelpdesk, isBccUser, userFeatures?.accountHelpdeskFeatureEnabled]
  )
}
